import * as React from 'react';

const ExpressFillIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="10"
    fill="none"
    viewBox="0 0 12 10"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M.75 7.75a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1H1.25a.5.5 0 0 1-.5-.5M0 5a.5.5 0 0 1 .5-.5h2.25a.5.5 0 0 1 0 1H.5A.5.5 0 0 1 0 5M1 2.25a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1H1.5a.5.5 0 0 1-.5-.5M8.184.035a.5.5 0 0 1 .312.531L8.07 3.75H9.99c.11 0 .225 0 .32.009a.8.8 0 0 1 .412.147.75.75 0 0 1 .292.566.8.8 0 0 1-.12.422 4 4 0 0 1-.179.265l-.01.014-3.298 4.618a.5.5 0 0 1-.903-.357L6.93 6.25H5.01c-.11 0-.225 0-.32-.009a.8.8 0 0 1-.412-.147.75.75 0 0 1-.292-.566.8.8 0 0 1 .12-.422c.048-.082.115-.175.179-.265l.01-.014L7.593.209a.5.5 0 0 1 .59-.174"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default ExpressFillIcon;
